export type DDSType = 'DDS' | 'PIT_STOP' | 'DIG' | 'DMI' | 'DDS_GERAL'

// ─── Lista de presença por QR ───────────────────────────────────
export type DDSAttendanceSource = 'BADGE_SCAN' | 'SELF_CHECKIN'

// Por quanto tempo o DDS fica aberto para receber participantes (definido na criação)
export const DDS_DURATION_OPTIONS = [15, 30, 60, 120] as const
export const DDS_DEFAULT_DURATION_MINUTES = 60

export interface DDSAttendanceStatus {
	ddsId: string
	subject: string
	isOpen: boolean
	closesAt: string
}

// Humorômetro escolhido no check-in por QR (verde / amarelo / vermelho)
export const DDS_MOODS = ['HAPPY', 'NEUTRAL', 'SAD'] as const
export type DDSMood = (typeof DDS_MOODS)[number]
export type DDSMoodSummary = Record<DDSMood, number>

export interface DDSAttendanceAttendee {
	id: string
	personName: string
	badge: string
	jobRole: string | null
	source: DDSAttendanceSource
	mood: DDSMood | null
	moodAction: string | null
	moodActionAt: string | null
	createdAt: string
}

// Emociograma: entradas com humor registrado, para acompanhar e registrar a ação tomada
export interface DDSEmotionEntry {
	attendeeId: string
	ddsId: string
	ddsSubject: string
	ddsDate: string
	crName: string
	branchName: string
	personName: string
	badge: string
	jobRole: string | null
	mood: DDSMood
	moodAction: string | null
	moodActionAt: string | null
	moodActionByName: string | null
	createdAt: string
}

export interface DDSEmotionListParams {
	mood?: DDSMood
	hasAction?: boolean
	startDate?: string
	endDate?: string
	crId?: string
	branchId?: string
	page?: number
	limit?: number
}

export interface DDSEmotionListOutput {
	items: DDSEmotionEntry[]
	moodSummary: DDSMoodSummary
	pagination: {
		page: number
		limit: number
		total: number
		totalPages: number
	}
}

export interface DDSAttendance extends DDSAttendanceStatus {
	total: number
	moodSummary: DDSMoodSummary
	attendees: DDSAttendanceAttendee[]
}

export interface DDSAttendanceQr {
	token: string
	expiresAt: string
	closesAt: string
}

export interface DDSCheckInResult {
	ddsId: string
	subject: string
	date: string
	alreadyRegistered: boolean
}

export interface DDSInput {
	crId: string
	customerId?: string
	branchId: string
	date: string
	subject: string
	type: DDSType
	description: string
	attendeeIds: string[] // Array of person IDs
	durationMinutes: number // tempo em que o DDS aceita participantes
	selfCheckIn?: boolean // participantes registram presença pelo QR Code
	image?: File
}

export interface DDSUpdateInput {
	customerId?: string
	attendeeIds?: string[]
	image?: File
}

export interface DDSAttendeeOutput {
	id: string
	employeeId: string
	personName: string
	personRegistration: string | null
	jobRole: string | null
	source: DDSAttendanceSource
	createdAt: string
}

export interface DDSOutput {
	id: string
	date: string
	type: DDSType
	subject: string
	description: string
	createdBy: string
	createdById: string
	branchName: string
	crName: string
	attendeesCount: number
	imagePath?: string
	attendees: DDSAttendeeOutput[]
	closesAt: string // instante em que o DDS deixa de aceitar participantes
	createdAt: string
}

export type DDSScope = 'mine' | 'branch' | 'cr'

export interface DDSMeListParams {
	scope?: DDSScope
	q?: string
	type?: DDSType
	customerId?: string
	cursor?: string
	activeBranchId?: string
	activeCrId?: string
	crId?: string
}

export interface DDSFacetBranch {
	id: string
	name: string
	count: number
}

export interface DDSFacetCR {
	id: string
	name: string
	count: number
}

export interface DDSFacetCustomer {
	id: string
	name: string
	count: number
}

export interface DDSMeListOutput {
	items: DDSOutput[]
	pageInfo: {
		nextCursor: string | null
		hasNext: boolean
	}
	facets: {
		branches: DDSFacetBranch[]
		crs: DDSFacetCR[]
		customers: DDSFacetCustomer[]
	}
	appliedFilters: {
		scope?: DDSScope
		customerId?: string
		activeBranchId?: string
		activeCrId?: string
		crId?: string
	}
}

export interface DDSListOutput {
	items: DDSOutput[]
	pagination: {
		page: number
		limit: number
		total: number
		totalPages: number
	}
}
